import React, { useContext } from "react";
import HEXBarChart from "@icons/hexpert/HEXBarChart";
import { FormGroup } from "../../components/FormGroup";
import { HexRadioItem } from "../../components/RadioItem";
import { RangeSlider } from "../../components/RangeSlider";
import { HexpertContext, unitSytems } from "../../contexts/HexPertProvider";
import { PageQuestion } from "../../types/hexpertTypes";
import {
  unitConverter,
  unitConvertName,
  UnitSystem,
  UnitTypes,
} from "../../helpers/unitsConversion";
import './HexpertPowerRangeElementBlock.scss';

export const HexpertPowerRangeElementBlock = ({
  Label,
  Max,
  Min,
  Step,
  FieldId,
  PredefinedValue,
}: PageQuestion) => {
  const { state, dispatch } = useContext(HexpertContext);

  return (
    <FormGroup title={Label}>
      <div className="c-hex-graph-range-slider-block-chart-container">
        <div className="c-hex-graph-range-slider-block-label">
          <p className="c-hex-graph-range-slider-block-title">
            {state?.formAnswers && state?.formAnswers[FieldId]
              ? Math.round(
                unitConverter(
                  UnitTypes.POWER,
                  state.unitSystem,
                  state?.formAnswers?.[FieldId]?.replace(":kW", "")
                )
              )
              : "-"}{" "}
            {unitConvertName(UnitTypes.POWER, state.unitSystem)}
          </p>
          {state.unitSystem !== UnitSystem.STANDARD &&
            state?.formAnswers?.[FieldId] && (
              <p className="c-hex-graph-range-slider-block-subTitle">
                {`( ${state?.formAnswers?.[FieldId]?.replace(
                  ":kW",
                  ""
                )} ${unitConvertName(UnitTypes.POWER, UnitSystem.STANDARD)} )`}
              </p>
            )}
        </div>
        <div className="c-hex-graph-range-slider-image-container">
          <HEXBarChart />
        </div>
      </div>
      <RangeSlider
        minValue={Min}
        maxValue={Max}
        interval={Step}
        name={Label}
        value={
          state?.formAnswers && state?.formAnswers[FieldId]
            ? Number(state?.formAnswers?.[FieldId]?.replace(":kW", ""))
            : PredefinedValue?.length > 0 && Number(PredefinedValue)
              ? Number(PredefinedValue)
              : 0
        }
        onChange={(val: number) =>
          dispatch({
            type: "setAnswer",
            payload: { [FieldId]: val.toString() },
          })
        }
      />
      <div className="c-hex-graph-range-slider-block-units">
        {unitSytems.map((unit) => (
          <HexRadioItem
            key={unit}
            label={unitConvertName(UnitTypes.POWER, unit)}
            name={Label + "unit"}
            onChange={() => {
              dispatch({ type: "setUnit", payload: unit });
            }}
            value={unit}
            selected={unit === state.unitSystem}
          />
        ))}
      </div>
    </FormGroup>
  );
};
